/**
 * Shared density class configuration for popup table layouts.
 * Used by PopupTargetsPage, PopupRoutesPage, PopupEventsPage, etc.
 */

export type TableDensity = 'normal' | 'compact';

export interface DensityClasses {
  tableCell: string;
  tableHeader: string;
  cellContent: string;
  button: string;
  text: string;
  cardHeader: string;
  icon: {
    small: string;
    medium: string;
    large: string;
  };
}

export const getDensityClasses = (density: TableDensity): DensityClasses => ({
  tableCell: density === 'compact' ? 'py-0 px-2' : 'py-1 px-4',
  tableHeader: density === 'compact' ? 'py-1 px-2' : 'py-2 px-4',
  cellContent: density === 'compact' ? 'py-0.5' : 'py-1',
  button: density === 'compact' ? 'size-6 p-0' : 'size-8 p-0',
  text: density === 'compact' ? 'text-xs' : 'text-sm',
  cardHeader: density === 'compact' ? 'px-4 py-2 pb-1' : 'px-7 py-4 pb-2',
  icon: {
    small: density === 'compact' ? 'size-3' : 'size-4',
    medium: density === 'compact' ? 'size-4' : 'size-5',
    large: density === 'compact' ? 'size-5' : 'size-6',
  },
});
